import React, { useEffect, useState } from 'react'
import {
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CImage,
  CInputGroup,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilExternalLink, cilLinkAlt, cilPencil, cilTrash } from '@coreui/icons'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { addBanner, deleteBanner, getBanner, updateBanner } from 'src/redux/banner'
import swal from 'sweetalert'

const Banner = () => {
  // const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    title: '',
    subtitle: '',
    description: '',
    image: '',
    link: '',
  })
  const [image, setImage] = useState(null)
  const handleImageChange = (e) => {
    const file = e.target.files[0]
    setImage(URL.createObjectURL(file))
    setFormData({ ...formData, image: file })
  }

  const dispatch = useDispatch()

  const { banners } = useSelector((state) => state.banners)

  useEffect(() => {
    dispatch(getBanner())
  }, [dispatch])

  const handleSubmit = async () => {
    if (!formData.title) {
      toast('Title required!', { type: 'info' })
    } else if (!formData.subtitle) {
      toast('Subtitle required!', { type: 'info' })
    } else if (!formData.description) {
      toast('Description required!', { type: 'info' })
    } else if (!formData.link) {
      toast('Link required!', { type: 'info' })
    } else if (!formData.image) {
      toast('Image required!', { type: 'info' })
    } else {
      const body = {
        title: formData.title,
        subtitle: formData.subtitle,
        description: formData.description,
        image: formData.image,
        link: formData.link,
      }
      const formDataToSend = new FormData()
      Object.keys(body).forEach((key) => {
        formDataToSend.append(key, body[key])
      })
      try {
        await dispatch(addBanner(formDataToSend))
        setFormData({
          title: '',
          subtitle: '',
          description: '',
          image: '',
          link: '',
        })
        setImage(null)
      } catch (error) {
        toast(error.message, { type: 'error' })
      }
    }
  }

  async function handleDelete(id) {
    await swal({
      title: 'Are you sure? ',
      text: 'You want to delete this banner!',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await dispatch(deleteBanner(id))
      } else {
        console.log(willDelete)
      }
    })
  }

  async function handleUpdate() {
    const body = {
      title: formData.title,
      subtitle: formData.subtitle,
      description: formData.description,
      image: formData.image,
      link: formData.link,
    }
    const formDataToSend = new FormData()
    Object.keys(body).forEach((key) => {
      formDataToSend.append(key, body[key])
    })
    await dispatch(updateBanner(formData?.uuid, formDataToSend))
    setFormData({ title: '', subtitle: '', description: '', image: '', link: '' })
    setImage(null)
  }

  const openLink = (link) => {
    window.open(link, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className="bg-light d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={9} lg={7} xl={8}>
            <CTable align="middle" className="mb-0 border" hover responsive>
              <CTableHead color="light">
                <CTableRow>
                  <CTableHeaderCell>Title</CTableHeaderCell>
                  <CTableHeaderCell>Subtitle</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Description</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Action</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {banners?.map((item, index) => (
                  <CTableRow v-for="item in tableItems" key={index}>
                    <CTableDataCell>
                      <div className="clearfix">
                        <small className="text-medium-emphasis">{item.title}</small>
                      </div>
                    </CTableDataCell>
                    <CTableDataCell>
                      <div className="clearfix">
                        <small className="text-medium-emphasis">{item.subtitle}</small>
                      </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div className="clearfix">
                        <small className="text-medium-emphasis">{item.description}</small>
                      </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CButtonGroup role="group" aria-label="Basic mixed styles example">
                        <CButton color="danger" size="sm" onClick={() => handleDelete(item.uuid)}>
                          <CIcon icon={cilTrash} className="text-white" />
                        </CButton>
                        <CButton color="warning" size="sm" onClick={() => setFormData(item)}>
                          <CIcon icon={cilPencil} className="text-dark" />
                        </CButton>
                        <CButton color="info" size="sm" onClick={() => openLink(item.image)}>
                          <CIcon icon={cilExternalLink} className="text-dark" />
                        </CButton>
                        <CButton color="success" size="sm" onClick={() => openLink(item.link)}>
                          <CIcon icon={cilLinkAlt} className="text-dark" />
                        </CButton>
                      </CButtonGroup>
                    </CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
          </CCol>
          <CCol md={9} lg={7} xl={4}>
            <CCard className="mx-4">
              <CCardBody className="p-4">
                <CForm>
                  <h5 className="text-medium-emphasis mb-3">
                    {formData?.id ? 'Update' : 'Add New'} Banner
                  </h5>
                  <CInputGroup className="mb-3">
                    <CFormInput
                      placeholder="Title"
                      autoComplete="Title"
                      value={formData.title}
                      onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                    />
                  </CInputGroup>
                  <CInputGroup className="mb-3">
                    <CFormInput
                      placeholder="Subtitle"
                      autoComplete="Subtitle"
                      value={formData.subtitle}
                      onChange={(e) => setFormData({ ...formData, subtitle: e.target.value })}
                    />
                  </CInputGroup>
                  <CInputGroup className="mb-3">
                    <CFormInput
                      placeholder="Description"
                      autoComplete="Description"
                      value={formData.description}
                      onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                    />
                  </CInputGroup>
                  <CInputGroup className="mb-3">
                    <CFormInput
                      placeholder="Link"
                      autoComplete="Link"
                      value={formData.link}
                      onChange={(e) => setFormData({ ...formData, link: e.target.value })}
                    />
                  </CInputGroup>
                  <div className="my-3">
                    <CFormInput type="file" size="sm" id="pickImage" onChange={handleImageChange} />
                  </div>
                  {image && (
                    <CImage
                      src={image && image}
                      style={{
                        width: '100%',
                        height: 150,
                        justifyContent: 'center',
                      }}
                    />
                  )}

                  <div className="d-grid mt-3">
                    <CButton color="success" onClick={formData?.id ? handleUpdate : handleSubmit}>
                      {formData?.id ? 'Update' : 'Submit'}
                    </CButton>
                  </div>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Banner
